// Packages
import React from "react"
import { Script } from "gatsby"
import {
  GlobalStyles,
  // eslint-disable-next-line no-unused-vars
  CSSVariables,
} from "@abmg-components"

// Components
import Layout from "@components/global/layout"
import LayoutWalledMB from "@components/global/layout-walled-mb"
import GlobalBanner from "@components/global/GlobalBanner"

// Utils
import { scripts } from "@utils/html.tsx"

// Browser APIs
// export const wrapRootElement = ({ element }) => {
//   return <GlobalContextProvider>{element}</GlobalContextProvider>
// }

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
      <GlobalStyles />
      {props.pageContext.type !== "noLayout" ? (
        props.pageContext.version === "mb" ||
        props.pageContext.type === "mb" ||
        props.pageContext.pageName?.match("404") ? (
          <>
            <LayoutWalledMB {...props}>{element}</LayoutWalledMB>
          </>
        ) : (
          <Layout {...props}>{element}</Layout>
        )
      ) : (
        element
      )}
      {typeof window !== "undefined" && (
        <GlobalBanner isFunnel={props.pageContext.isFunnel} />
      )}
      {scripts[
        Object.keys(scripts).find(key => {
          if (
            props.path.match(key) ||
            props.location.pathname.match(key) ||
            props.params?.mb === key
          )
            return true
        })
      ]?.map(script => {
        return script
      })}
      <Script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": ["Organization", "FinancialService"],
              "@id": "https://www.atlanticbay.com/#organization",
              name: "Atlantic Bay Mortgage Group",
              legalName: "Atlantic Bay Mortgage Group, L.L.C.",
              url: "https://www.atlanticbay.com/",
              logo: {
                "@type": "ImageObject",
                "@id": "https://www.atlanticbay.com/#logo",
                url: "https://www.atlanticbay.com/abay-icon.png",
                width: 512,
                height: 512,
              },
              description:
                "Atlantic Bay Mortgage Group is a mortgage lender providing home purchase loans, refinancing, FHA, VA, USDA, jumbo, and first-time homebuyer mortgage programs throughout the Southeast and Mid-Atlantic.",
              foundingDate: "1996",
              founder: {
                "@type": "Person",
                name: "Brian Holland",
              },
              slogan: "Lending Peace of Mind",
              telephone: "+1-757-213-1660",
              address: {
                "@type": "PostalAddress",
                streetAddress: "600 Lynnhaven Parkway Suite 100",
                addressLocality: "Virginia Beach",
                addressRegion: "VA",
                postalCode: "23452",
                addressCountry: "US",
              },
              areaServed: [
                {
                  "@type": "State",
                  name: "Virginia",
                },
                {
                  "@type": "State",
                  name: "North Carolina",
                },
                {
                  "@type": "State",
                  name: "Florida",
                },
                {
                  "@type": "State",
                  name: "Georgia",
                },
              ],
              identifier: [
                {
                  "@type": "PropertyValue",
                  name: "NMLS Consumer Access ID",
                  propertyID: "NMLS",
                  value: "72043",
                },
              ],
              contactPoint: [
                {
                  "@type": "ContactPoint",
                  telephone: "+17572131660",
                  contactType: "customer service",
                  availableLanguage: ["English", "Spanish"],
                },
              ],
              knowsAbout: [
                "Mortgage lending",
                "Home loans",
                "Mortgage refinance",
                "First-time homebuyer loans",
                "FHA loans",
                "VA loans",
                "USDA loans",
                "Conventional loans",
                "Jumbo loans",
              ],
              sameAs: [
                "https://www.facebook.com/AtlanticBay/",
                "https://www.linkedin.com/company/atlantic-bay-mortgage-group",
                "https://www.instagram.com/atlanticbaymortgagegroup/",
                "https://www.youtube.com/@atlanticbaymortgagegroup4029",
                "https://www.tiktok.com/@atlanticbaymortgagegroup",
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.atlanticbay.com/#website",
              url: "https://www.atlanticbay.com/",
              name: "Atlantic Bay Mortgage Group",
              publisher: {
                "@id": "https://www.atlanticbay.com/#organization",
              },
            },
          ],
        })}
      </Script>
    </>
  )
}
